import { Field, Input, makeStyles, tokens } from '@fluentui/react-components';
import { useCallback, useMemo } from 'react';
import { TextAreaHelperText, TextAreaWithHighLights } from 'src/pages/automation-rule/work-item-variables';
import { useAutomationRuleActions } from '../use-actions';
import { ActionItemType, SendNotificationToSlackActionType, SendNotificationToSlackErrorType } from '../types';

interface Props {
	actionId: string;
	validations: SendNotificationToSlackErrorType | null;
}

export default function SendNotificationToSlack(props: Props) {
	const classes = useStyles();
	const {actions, setActions} = useAutomationRuleActions();

	const currentAction = useMemo(() => {
		const found = actions.find(item => item.id === props.actionId) as ActionItemType;
		return found.sendNotificationToSlack as SendNotificationToSlackActionType;
	}, [actions, props.actionId]);

	const onChanfeWebHookUrlValue = useCallback((value: string) => {
		setActions(oldActions => {
			const current = oldActions.find(item => item.id === props.actionId) as ActionItemType;
			const others = oldActions.filter(item => item.id !== props.actionId);
			return [
				...others,
				{
					...current,
					sendNotificationToSlack: {
						...current.sendNotificationToSlack as SendNotificationToSlackActionType,
						webHookUrl: value
					}
				}
			];
		});
	}, [actions, props.actionId]);

	const changeTextValue = useCallback((value: string) => {
		setActions(oldActions => {
			const current = oldActions.find(item => item.id === props.actionId) as ActionItemType;
			const others = oldActions.filter(item => item.id !== props.actionId);
			return [
				...others,
				{
					...current,
					sendNotificationToSlack: {
						...current.sendNotificationToSlack as SendNotificationToSlackActionType,
						text: value
					}
				}
			];
		});
	}, [actions, props.actionId]);

	return (
		<div className={classes.root}>
			<Field
				className={classes.fieldRoot}
				validationMessage={props.validations?.webHookUrl}
			>
				<Input
					placeholder='Webhook URL'
					appearance='outline'
					className={classes.input}
					value={currentAction.webHookUrl}
					onChange={(_, data) => {
						onChanfeWebHookUrlValue(data.value);
					}}
				/>
			</Field>
			<div className={classes.fieldRoot}>
				<Field
					validationMessage={props.validations?.text}
				>
					<TextAreaWithHighLights
						messageError={props.validations?.text}
						placeholder='Slack message'
						value={currentAction.text}
						onChange={(value) => {
							changeTextValue(value);
						}}
					/>
				</Field>
				<TextAreaHelperText />
			</div>
		</div>
	);
}

export const useStyles = makeStyles({
	root: {
		width: '100%',
		gap: '8px',
		display: 'flex',
		flexDirection: 'column',
		// position: 'relative'
	},
	fieldRoot: {
		width: '100%'
	},
	input: {
		width: '100%',
		border: `1px solid ${tokens.colorNeutralStroke1}`,
		outline: 'none',
		'::after': {
			borderBottom: 'none',
			height: 0,
		},
		':hover': {
			background: tokens.colorNeutralBackground4Hover,
			border: `1px solid ${tokens.colorNeutralStroke1Hover}`
		},
		':focus-within': {
			background: tokens.colorNeutralBackground4Hover,
			border: `1px solid ${tokens.colorNeutralStroke1}`,
			borderBottomColor: `${tokens.colorNeutralStroke1}!important`,
			borderTopColor: `${tokens.colorNeutralStroke1}!important`,
			borderRightColor: `${tokens.colorNeutralStroke1}!important`,
			borderLeftColor: `${tokens.colorNeutralStroke1}!important`,
		},
	}
});